import script from "./ManagerTimesheetReviewView.vue?vue&type=script&setup=true&lang=js"
export * from "./ManagerTimesheetReviewView.vue?vue&type=script&setup=true&lang=js"

import "./ManagerTimesheetReviewView.vue?vue&type=style&index=0&id=87f4d56c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-87f4d56c"]])

export default __exports__